"use strict";

;

(function () {
  var searchWrapper = document.querySelector('.search-wrapper');
  var toggleSearch = document.querySelector('.toggle-search');
  var mobileToggleSearch = document.querySelector('#mobile-search');
  var mobileSearchWrapper = document.querySelector('.mobile-search'); // Does not have open class

  toggleSearch.addEventListener('click', function (event) {
    event.preventDefault();
    searchWrapper.classList.toggle('is-open');

    if (searchWrapper.classList.contains('is-open')) {
      ga_track('search', 'click', 'open');
    } else {
      ga_track('search', 'click', 'close');
    }
  });
  mobileToggleSearch.addEventListener('click', function (event) {
    event.preventDefault();
    mobileToggleSearch.classList.toggle('is-open');
    mobileSearchWrapper.classList.toggle('is-open');

    if (mobileSearchWrapper.classList.contains('is-open')) {
      ga_track('mobile search', 'click', 'open');
    } else {
      ga_track('mobile search', 'click', 'close');
    }
  });
})();